import Head from 'next/head'
import Logo from "@/components/general/Logo";
import Footer from "@/components/general/Footer";
import {useIntl} from "react-intl";
import loadI18nMessages from "@/components/general/load_int_messages";

export async function getStaticProps(ctx) {
  return {
    props: {
      intlMessages: await loadI18nMessages(ctx),
    },
  }
}

export default function Feedback() {
  const intl = useIntl()
  return (
    <div style={{
      backgroundColor: "rgb(47, 52, 55)"
    }}>
      <Head>
        <title>FlitsPils</title>
        <meta name="description" content={intl.formatMessage(
          {
            description:"Feedback header",
            defaultMessage:"We'd like to hear what you think about Flitspils!"
          })} />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className="p-5 container mx-auto min-h-screen justify-center">
        <div>
          <Logo style={{color: "white"}}/>
        </div>
        <div className={"mt-10"}>
          <iframe className={"max-w-md w-full h-[40rem] rounded mx-auto"} src="https://notionforms.io/forms/flitspils-feedback" />
        </div>
      </div>
      <Footer />
    </div>
  )
}
